<template>
  <div class="">
    <procedures></procedures>
  </div>
</template>

<script>
import Procedures from "@/components/communication/procedures/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    Procedures,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "LisaComunica",
        path: "",
        level: 2,
      });
      bcs.push({
        text: "Procedure",
        path: "communication_procedures.index",
        level: 2,
      });
      bcs.push({
        text: "Modifica Procedura",
        path: "communication_procedures.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "LisaComunica",
        path: "",
        level: 2,
      });
      this.notifyQueue({
        text: "Procedure",
        path: "communication_procedures.index",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Procedura",
        path: "communication_procedures.edit",
        level: 4,
      });
    }
  },
};
</script>
